import { func } from 'prop-types';
import { Component } from 'react';

// Execute a function on mount. Useful to use as a child of <LazyLoad />

class TriggerOnMount extends Component {
  componentDidMount() {
    this.props.fn();
  }
  render() {
    return null;
  }
}

TriggerOnMount.propTypes = {
  fn: func.isRequired
};

export default TriggerOnMount;
